var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5002 14.1841C30.057 10.9885 28.5773 8.02762 26.2891 5.75746C24.001 3.48729 21.0313 2.03383 17.8375 1.62096C14.6437 1.20809 11.4031 1.85871 8.61467 3.47261C5.82628 5.08651 3.64488 7.57415 2.40649 10.5523M1.50024 3.28876V10.5523H8.75024M1.50024 17.8159C1.94351 21.0115 3.42318 23.9724 5.71134 26.2425C7.99949 28.5127 10.9692 29.9662 14.163 30.379C17.3567 30.7919 20.5974 30.1413 23.3858 28.5274C26.1742 26.9135 28.3556 24.4259 29.594 21.4477M30.5002 28.7112V21.4477H23.2502",
    stroke: "#D6AF66",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.e1238940b54f674c57d82ae9bafb5380.svg";
export { ForwardRef as ReactComponent };